import React from 'react';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';


const transform = (node, index) => {
	if (node.type === 'tag' && node.name === 'svg') {
	  const child1 = node.children[0];
	  const child2 = node.children[1];
	  const child3 = node.children[2];
	  const child4 = node.children[3];
	  const { width, height, viewbox, xmlns } = node.attribs;
	  return (
		<svg
		  key={index}
		  width={width}
		  height={height}
		  viewBox={viewbox}
		  xmlns={xmlns}
		>
		  {convertNodeToElement(child1, index, transform)}
		  {convertNodeToElement(child2, index+1, transform)}
		  {convertNodeToElement(child3, index+2, transform)}
		  {convertNodeToElement(child4, index+3, transform)}
		</svg>
	  );
	}
  }

  export const htmlToJsx =  (element) => {
	return ReactHtmlParser(element, {transform: transform})
  }